import { render, staticRenderFns } from "./settings-account-contact.vue?vue&type=template&id=f520c02e&scoped=true&"
import script from "./settings-account-contact.vue?vue&type=script&lang=js&"
export * from "./settings-account-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f520c02e",
  null
  
)

export default component.exports